import {IStyle} from 'fela'
import {useFela} from 'react-fela'
import {Theme} from '../../../app/theme'

const DIVIDER_SPACING = 60
const DIVIDER_MAX_WIDTH = 480

export function ArDivider() {
  const {css, theme} = useFela<Theme>()

  const dividerStyle: IStyle = {
    border: 0,
    borderTop: `1px solid ${theme.colors.border}`,
    width: '80%',
    maxWidth: DIVIDER_MAX_WIDTH,
    marginTop: DIVIDER_SPACING,
    marginBottom: DIVIDER_SPACING,
    marginLeft: 'auto',
    marginRight: 'auto',
  }

  return <hr className={css(dividerStyle)} />
}
